<template>
  <div>
    <p>请在微信中打开</p>
  </div>
</template>
<script>
export default {
  name: "notwechatbrowse",
  data() {
    return {};
  },
  method: {},
};
</script>